import "./loading.scss";

import loadingGif from "../assets/loading.gif";

const Loading = () => {
  return <img src={loadingGif} alt="Loading" id="loading" />;
};

export default Loading;
